import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
const textAlignOptions = [
    {
        align: 'center',
        icon: '/images/format_align_center.svg',
    },
    {
        align: 'left',
        icon: '/images/editor/format_align_left.svg',
    },
    {
        align: 'right',
        icon: '/images/editor/format_align_right.svg',
    },
];
const TextAlignSwitcher = ({ currentAlign, onChange, }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        setCurrentIndex(textAlignOptions.findIndex((option) => option.align === currentAlign));
    }, [currentAlign]);
    const handleClick = () => {
        const nextIndex = (currentIndex + 1) % textAlignOptions.length;
        setCurrentIndex(nextIndex);
        onChange(textAlignOptions[nextIndex].align);
    };
    return (_jsx("img", { src: textAlignOptions[currentIndex].icon, className: "action-item", onClick: handleClick, alt: "Text Align", style: { cursor: 'pointer' } }));
};
export default TextAlignSwitcher;
